module.exports = __webpack_public_path__ + "img/icon_genset.2e41252e.png";